import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, STUDENT_QUIZ_BY_ID, STUDENT_QUIZ_LIST } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const STUDENT_QUIZ_ASSESSMENT = GLOBAL_STATE

export const { reducer: studentQuizReducer } = createSlice({
  name: STUDENT_QUIZ_ASSESSMENT,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.studentQuizById.pending, state => {
        state[STUDENT_QUIZ_BY_ID].loading = true
      })
      .addCase(actionCreators.studentQuizById.rejected, (state, action) => {
        state[STUDENT_QUIZ_BY_ID].loading = false
        state[STUDENT_QUIZ_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentQuizById.fulfilled, (state, action) => {
        state[STUDENT_QUIZ_BY_ID].loading = false
        state[STUDENT_QUIZ_BY_ID].error = null
        state[STUDENT_QUIZ_BY_ID].data = action.payload
      })

    builder
      .addCase(actionCreators.studentQuizList.pending, state => {
        state[STUDENT_QUIZ_LIST].loading = true
      })
      .addCase(actionCreators.studentQuizList.rejected, (state, action) => {
        state[STUDENT_QUIZ_LIST].loading = false
        state[STUDENT_QUIZ_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentQuizList.fulfilled, (state, action) => {
        state[STUDENT_QUIZ_LIST].loading = false
        state[STUDENT_QUIZ_LIST].error = null
        state[STUDENT_QUIZ_LIST].data = action.payload
      })

    // builder
    //   .addCase(actionCreators.studentQuizAll.pending, state => {
    //     state[STUDENT_QUIZ_ALL].loading = true
    //   })
    //   .addCase(actionCreators.studentQuizAll.rejected, (state, action) => {
    //     state[STUDENT_QUIZ_ALL].loading = false
    //     state[STUDENT_QUIZ_ALL].error = action.payload as AxiosError
    //   })
    //   .addCase(actionCreators.studentQuizAll.fulfilled, (state, action) => {
    //     state[STUDENT_QUIZ_ALL].loading = false
    //     state[STUDENT_QUIZ_ALL].error = null
    //     state[STUDENT_QUIZ_ALL].data = action.payload
    //   })

    // builder
    //   .addCase(actionCreators.studentQuizSelect.pending, state => {
    //     state[STUDENT_QUIZ_SELECT].loading = true
    //   })
    //   .addCase(actionCreators.studentQuizSelect.rejected, (state, action) => {
    //     state[STUDENT_QUIZ_SELECT].loading = false
    //     state[STUDENT_QUIZ_SELECT].error = action.payload as AxiosError
    //   })
    //   .addCase(actionCreators.studentQuizSelect.fulfilled, (state, action) => {
    //     state[STUDENT_QUIZ_SELECT].loading = false
    //     state[STUDENT_QUIZ_SELECT].error = null
    //     state[STUDENT_QUIZ_SELECT].data = action.payload
    //   })

    builder.addCase(actionCreators.studentQuizByIdClear, state => {
      state[STUDENT_QUIZ_BY_ID] = defaultState()
    })

    // builder.addCase(actionCreators.studentQuizAllClear, state => {
    //   state[STUDENT_QUIZ_ALL] = defaultState()
    // })

    // builder.addCase(actionCreators.studentQuizSelectClear, state => {
    //   state[STUDENT_QUIZ_SELECT] = defaultState()
    // })

    builder.addCase(actionCreators.studentQuizListClear, state => {
      state[STUDENT_QUIZ_LIST] = defaultState()
    })
  },
})
